import script from "./FormulasActions.vue?vue&type=script&setup=true&lang=js"
export * from "./FormulasActions.vue?vue&type=script&setup=true&lang=js"

import "./FormulasActions.vue?vue&type=style&index=0&id=08629123&lang=scss"

const __exports__ = script;

export default __exports__